import { Fragment } from 'react'

import { AOSRJsonType, SecondaryActJsonType } from '../../Types/dataJSON'
import { H1 } from '../molecules/H1'
import { Paragraph } from '../molecules/Paragraph'
import { SubDescription } from '../molecules/SubDescription'
import { ISelectActSection } from '../template.type'

type SelectSectionType = {
  section: ISelectActSection
  actItems: AOSRJsonType | SecondaryActJsonType
  onToggle: (item: ISelectActSection & { value: string }) => void
  selectedField?: any
}

export const SelectSection = ({
  section,
  actItems,
  selectedField,
  onToggle,
}: SelectSectionType) => {
  const value = actItems[section.key]?.value

  return (
    <Fragment>
      <H1>{section.title}</H1>
      <Paragraph
        isEditable
        id={section.key}
        selectedId={selectedField}
        onToggle={() =>
          onToggle({
            ...section,
            value,
          })
        }
      >
        {value}
      </Paragraph>
      {section.sub_description && (
        <SubDescription id={section.sub_description}>
          {section.sub_description}
        </SubDescription>
      )}
    </Fragment>
  )
}
